/**
 * Tiny event bus so any component that has the current displayed temperature
 * can publish it, and any component (e.g. the InfoDialog mascot) can react.
 * Lighter than wiring a context through every layer, idempotent, no deps.
 */
const EVENT = 'layers-today:mood';

export const publishMood = (tempCelsius, conditions = {}) => {
  if (typeof window === 'undefined') return;
  const detail = { tempCelsius, conditions };
  try { sessionStorage.setItem('layers-today:mood', JSON.stringify(detail)); } catch {}
  window.dispatchEvent(new CustomEvent(EVENT, { detail }));
};

export const readLastMood = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem('layers-today:mood');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const subscribeMood = (cb) => {
  if (typeof window === 'undefined') return () => {};
  const handler = (e) => cb(e.detail);
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
};

/**
 * Mascot mapping. Kept here so other components (e.g. an embed badge) can
 * reuse the same vocabulary later.
 *
 * Rain takes precedence over temperature because being wet matters more than
 * being warm/cold for what you wear.
 */
export const moodEmoji = ({ tempCelsius, conditions } = {}) => {
  if (conditions?.precipitation > 0.5) return '🌧️';
  if (tempCelsius == null) return '🌻';
  if (tempCelsius <= -5) return '🥶';
  if (tempCelsius >= 26) return '🌵';
  return '🌻';
};
